export default {
    props: {
        isEditing: {
            type: Boolean,
            default: false
        },
        lng: {
            default () {
                return '105.75265156997759';
            }
        },
        lat: {
            default () {
                return '38.40060989162714';
            }
        },
        zoom: {
            type: Number,
            default () {
                return 5;
            }
        },
        scale: {
            default () {
                return 1;
            }
        },
        showMap: {
            type: Boolean,
            default: true
        }
    }
}